import { render } from "./TertiaryNav.vue?vue&type=template&id=4b98881e&ts=true"
import script from "./TertiaryNav.vue?vue&type=script&lang=ts"
export * from "./TertiaryNav.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__